import axios from 'axios'
import { IdType, VehiclePosition } from '../types'

const url = process.env.REACT_APP_LOCATION_TRACKING_FUNCTIONS_HOST || ''

async function getVehicles(
  id: string,
  idType: IdType
): Promise<VehiclePosition[]> {
  const { data } = await axios.get(`${url}/locations`, {
    params: {
      [idType]: id,
    },
  })
  return data.data
}

export default {
  getVehicles,
}
